import { IResponseEventsLog, IEventExportRow } from "./interfaces";
import { IGetEventTypeProps } from "../../../../../../utils/event";

interface ITransformEventsDeps {
  formatDate: (date: string) => string;
  formatMessage: (descriptor: { id: string }) => string;
  getEventType: (params: IGetEventTypeProps) => string;
  getMessage: (item: IResponseEventsLog) => string;
}

export const mapEventsToRows = (json: IResponseEventsLog[] | null, deps: ITransformEventsDeps): IEventExportRow[] => {
  if (!json?.length) return [];

  const { formatDate, formatMessage, getEventType, getMessage } = deps;

  return json.map(item => ({
    id: item.idEvent,
    idEvent: item.idEvent,
    ackStatus: item.Flags,
    status: item.DataAlarmStatus,
    type: getEventType({ type: item.EventType, subType: item.EventSubType }),
    pointName: item.PointName ?? "",
    date: formatDate(item.EventLogDate),
    parameter:
      typeof item.MeasureType === "number"
        ? formatMessage({ id: `pages.journals.popup.train.points.${item.MeasureType}` })
        : "",
    source: "",
    fullName: item.UserLogin ?? "",
    message: getMessage(item),
    defect: "",
  }));
};
